import type { ReactNode } from 'react';

interface PageToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  /** Optional controls rendered before the search field (e.g. year/month filters). */
  leading?: ReactNode;
  /** When omitted, the sort dropdown is hidden. */
  sortValue?: string;
  sortOptions?: string[];
  onSortChange?: (value: string) => void;
  action?: ReactNode;
}

export function PageToolbar({
  search,
  onSearchChange,
  searchPlaceholder = 'Search…',
  leading,
  sortValue,
  sortOptions,
  onSortChange,
  action,
}: PageToolbarProps) {
  const showSort =
    Boolean(sortOptions?.length) && sortValue != null && typeof onSortChange === 'function';

  return (
    <div className="page-toolbar">
      {leading}
      <div className="page-toolbar__search-wrap">
        <input
          className="field-input page-toolbar__search"
          type="text"
          inputMode="search"
          autoComplete="off"
          placeholder={searchPlaceholder}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      {showSort ? (
        <select
          className="field-input page-toolbar__sort"
          value={sortValue}
          onChange={(e) => onSortChange?.(e.target.value)}
        >
          {sortOptions!.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : null}
      {action}
    </div>
  );
}
